import skateChurch from "../assets/images/skate-church.png";
import desciple from "../assets/images/13th-desciple.png";
import pizzys from "../assets/images/pizzys-pizza.png";
import apiFun from "../assets/images/api-fun-meta-img.png";

const projects = [
   {
    title: "API Fun",
    description:
      "API Fun is a creative playground for exploring real APIs. Search Spotify artists, albums, songs, and discover movies all in one place.",
    tech: ["React", "JavaScript", "CSS", "Responsive Design"],
    image: apiFun,
    live: "https://freshfindsatl.com/",
    github: "https://github.com/phillipharden/playfit",
  },
  {
    title: "Skate Church ATL",
    description:
      "A React website promoting Skate Church ATL events, outreach, and community connection through skate culture.",
    tech: ["React", "JavaScript", "CSS", "Responsive Design"],
    image: skateChurch,
    live: "https://skatechurchatl.com/",
    github: "https://github.com/phillipharden/sk8churchatl",
  },
  {
    title: "13th Desciple",
    description:
      "Artist website for Christian Hip-Hop artist 13th Desciple featuring music, content, and brand presentation.",
    tech: ["React", "JavaScript", "CSS"],
    image: desciple,
    live: "https://13thdesciple.com/",
    github: "https://github.com/phillipharden/13thDesciple",
  },
  {
    title: "Pizzy's Pizza",
    description:
      "A responsive restaurant website concept showcasing menu items, branding, and a playful user interface for a fictional pizza brand.",
    tech: ["HTML", "CSS", "JavaScript", "Responsive Design"],
    image: pizzys,
    live: "https://phillipharden.github.io/pizzyspizza/",
    github: "https://github.com/phillipharden/pizzyspizza",
  },
];

export default projects;